import { lazy } from 'react';

const CharityVettingCharityNumberRoute = lazy(
  () =>
    import(
      /* webpackChunkName: "CharityNumber" */ '../components/steps/charity-number-step/CharityNumber'
    ),
);

export default CharityVettingCharityNumberRoute;
